// Cart persisted in localStorage. Items: {id, productSku, name, opts, unitPrice, qty, image}
const KEY = 'lugs_cart_v1'
const listeners = new Set()

function read() {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

let items = read()

function commit(next) {
  items = next
  localStorage.setItem(KEY, JSON.stringify(items))
  listeners.forEach((fn) => fn(items))
}

export const cart = {
  get: () => items,
  count: () => items.reduce((n, it) => n + it.qty, 0),
  subtotal: () => items.reduce((n, it) => n + it.unitPrice * it.qty, 0),
  add(item) {
    const existing = items.find((it) => it.id === item.id)
    if (existing) {
      commit(items.map((it) => (it.id === item.id ? { ...it, qty: it.qty + item.qty } : it)))
    } else {
      commit([...items, item])
    }
  },
  setQty(id, qty) {
    if (qty <= 0) return cart.remove(id)
    commit(items.map((it) => (it.id === id ? { ...it, qty } : it)))
  },
  remove(id) {
    commit(items.filter((it) => it.id !== id))
  },
  clear() {
    commit([])
  },
  subscribe(fn) {
    listeners.add(fn)
    return () => listeners.delete(fn)
  },
}
